export type RecruitmentImage = {
  id: string;
  url: string;
  file?: File;
  dbId?: number;
};

// こだわり条件(デフォルト項目から)
export type PreferenceConditions = {
  featureIds: number[];
  candidateRequirementIds: number[];
  workplaceIds: number[];
  averageAgeIds: number[];
  genderRatioIds: number[];
  workEnvironmentIds: number[];
  workStyleIds: number[];
  holidaysVacationIds: number[];
  dressCodeBenefitIds: number[];
  compensationEvaluationIds: number[];
  socialInsuranceIds: number[];
  welfareIds: number[];
  selectionConfigurationIds: number[];
};

export type PreferenceTargetType = 'default' | 'custom';

// こだわり条件(自由入力から)
export type CustomConditions = {
  features: string[];
  candidateRequirements: string[];
  workEnvironments: string[];
  workStyles: string[];
  holidaysVacations: string[];
  dressCodeBenefits: string[];
  compensationEvaluations: string[];
  socialInsurances: string[];
  welfares: string[];
  selectionConfigurations: string[];
};

export type RecruitmentContentForm = {
  images: RecruitmentImage[];
  title: string;
  whatTodoContent: string;
  whyNeedContent: string;
  workingTime: string;
  address: string | null;
  workingPeriodId: number | null;
  trialPeriodId: number | null;
  wages: string;
  welfareOther: string;
  firstMessage: string;
  salaryTypeId: number | null;
  salaryMin: number | null;
  salaryMax: number | null;
  salaryRangeMin: number | null;
  multipleAddress: boolean;
  occupationIds: (number | null)[]
  occupationDetailIds: (number | null)[];
  employmentTypeIds: number[];
  keywords: string;
  requiredProfileIds: number[];
  prefectureId: number | null;
  cityId: number | null;
  otherAddress: string;
  companyName: string;
  isPublished: boolean;
  brandId: number | null;
  magUrls: string;
  plannedHiresMin: number | null;
  plannedHiresMax: number | null;
} & PreferenceConditions  // こだわり条件(デフォルト項目から)
  & CustomConditions;  // こだわり条件(自由入力から)

export type SelectOption = {
  id: number;
  name: string;
};

export type EmploymentType = SelectOption;

export type Occupation = SelectOption;

export type OccupationDetail = SelectOption & {
  occupationId: number;
};

export type RequiredProfile = SelectOption;

export type Prefecture = SelectOption;

export type City = SelectOption;

export type WorkingPeriod = SelectOption;

export type TrialPeriod = SelectOption;

export type SalaryType = SelectOption;

export type SalaryRange = SelectOption & {
  value: number;
};

export type PreferenceCondition = SelectOption;

export type Section =
  | 'recruitmentContents'
  | 'companyProfile'
  | 'companyPeople'
  | 'recruitmentRelease';

export type RecruitmentContent = {
  recruitmentForm: RecruitmentContentForm;
};

export type RecruitmentFormSelectOption = {
  options: EmploymentType[] | Occupation[] | OccupationDetail[] |
           RequiredProfile[] | Prefecture[] | WorkingPeriod[] |
          //  TrialPeriod[] | SalaryType[] | SocialInsurance[] |
          //  Welfare[];
           TrialPeriod[] | SalaryType[] | PreferenceCondition[]
};

export type CityName = {
  cityName: string;
};

export type SalaryTypeName = {
  salaryTypeName: string;
};

export type RecruitmentResponse = {
  status: string;
  flash: boolean;
  flashType: string;
  flashMessage: string;
  recruitmentId?: number;
};

export type ReleaseInfo = {
  isUnreleased: boolean;
  isStopped?: boolean;
  isPublished: boolean;
  noCompanyProfile?: boolean;
};

export type RecruitmentReleaseInfo = {
  releaseInfo: ReleaseInfo;
};

export type Flash = {
  flash: boolean;
  flashType?: string;
  flashMessage?: string;
};

export const MAX_RECRUITMENT_IMAGES = 5;
